/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React from "react";
import LayoutPublicRoutes from "@/src/containers/Layouts/LayoutPublicRoutes";
import { Helmet } from "react-helmet-async";
import TeamSection from "@/src/components/Sections/Generic/TeamSection/TeamSection";
import PartnersSection from "@/src/components/Sections/Generic/PartnersSection/PartnersSection";
import { gaSet } from "@/src/services/googleAnalyticsService";
import AreasOfLaw from "@/src/components/Sections/Generic/AreasOfLaw/AreasOfLaw";
import OurValues from "@/src/components/Sections/Generic/OurValues/OurValues";
import YourServiceWorld from "@/src/components/Sections/Generic/YourServiceWorld/YourServiceWorld";
import CustomerFeedback from "@/src/components/Sections/Generic/CustomerFeedback/CustomerFeedback";

const AboutUsPage = () => {
  const title = "Über uns | Legalbird";
  gaSet({ title: title });

  return (
    <LayoutPublicRoutes>
      <Helmet>
        <title>{title}</title>
      </Helmet>
      <OurValues />
      <TeamSection
        headline={"Gemeinsam erreichen wir mehr - Unser Team"}
        subHeadline={
          "Wir arbeiten jeden Tag mit viel Freude daran, Ihre rechtlichen Probleme zu lösen und Ihnen so das Leben leichter zu machen. Hier sehen Sie einige Gesichter der Menschen, die sich täglich für Sie einsetzen."
        }
        subHeadlineVariant={"h6"}
      />
      <AreasOfLaw />
      <PartnersSection />
      <YourServiceWorld />
      <CustomerFeedback />
    </LayoutPublicRoutes>
  );
};

export default AboutUsPage;
